import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CommonHelper } from 'src/app/helpers/common';
import { UserHelper } from 'src/app/helpers/user';
import { UserModel } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service';
declare var $: any;
declare var videojs: any;

@Component({
  selector: 'app-playerapp',
  templateUrl: './playerapp.component.html',
  styleUrls: ['./playerapp.component.css']
})
export class PlayerappComponent implements OnInit {
  public videoUrl:any = '';
  public urlNotFound = false;
  private mlbId = '';
  private user:UserModel = this.userHelper.getUser(); 

  constructor(
    private activatedRoute: ActivatedRoute,
    private streaming: StreamingService,
    private domSanitizer: DomSanitizer,
    private commonHelper:CommonHelper,
    private userHelper:UserHelper
  ) { 
    this.mlbId = this.activatedRoute.snapshot.paramMap.get('mlb_id');
  }

  ngOnInit() {
    this.commonHelper.currentUrl = 'playerapp';
    if (this.mlbId !== '' && this.mlbId != null) {
      this.streaming.getGameByMlbId(this.mlbId).subscribe((resp: any) => {
        let game = resp.response;
        if (game['status'] == 'On Demand') {
          this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${game['ondemand']}`);
        } else {
          this.urlNotFound = true;
        }
      }, error => {
        this.urlNotFound = true;
      });
    } else {
      this.urlNotFound = true;
    }

  }

}
